export default {
  dataType: {
    DataIdentifier: 'Signal',
    MeaningIdentifier: 'Meaning',
  },
};
